import { render, staticRenderFns } from "./BusquedaPersonas.vue?vue&type=template&id=b2c53afe"
import script from "./BusquedaPersonas.vue?vue&type=script&lang=js"
export * from "./BusquedaPersonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports